import { AuthKitProvider, useAuth as useWorkOSAuth } from '@workos-inc/authkit-react';
import { ReactNode, useEffect } from 'react';

import { globalConfig } from './configuration/config';

interface WorkOSAuthProviderProps {
  children: ReactNode;
}

/**
 * WorkOS AuthKit provider wrapping the React tree.
 *
 * - Reads `workosClientId` from the runtime config.
 * - Strips OAuth callback params from the URL after a successful login.
 */
export const WorkOSAuthProvider = ({ children }: WorkOSAuthProviderProps) => {
  return (
    <AuthKitProvider
      clientId={globalConfig.config.workosClientId}
      devMode={globalConfig.config.environment !== 'production'}
      onRedirectCallback={() => {
        window.history.replaceState({}, document.title, window.location.pathname);
      }}
    >
      {children}
    </AuthKitProvider>
  );
};

/**
 * Hook for accessing AuthKit's auth state and methods.
 */
export const useAuth = () => useWorkOSAuth();

/**
 * Hook that triggers a sign-in flow when the user lands on `/login`.
 */
export const useLoginRoute = () => {
  const { signIn } = useWorkOSAuth();

  useEffect(() => {
    if (window.location.pathname === '/login') {
      signIn();
    }
  }, [signIn]);
};

export { useWorkOSAuth };
